    <template>
    <div :id="'dropzone_id' + this.unq_id_gen" class="dropzone">
        <div>
            <div class="fallback">
                <input type="file" :name="file_name" multiple=true>
            </div>
            <div class="dropzone-previews row" :id="'dropzone_preview' + this.unq_id_gen">

            </div>
            <div>
                <div :id="'vx_left_side' + this.unq_id_gen"></div>
                <div>
                    <div :id="'drop_msg' + this.unq_id_gen">
                        <div class="dz-message" data-dz-message>
                            <!-- <button @click.prevent :id="upload_files" class="btn vx_button browse">files <i class="fas fa-print"></i></button> -->
                        </div>
                    </div>
                    <!-- <div :id="vx_preview_loc"></div> -->
                </div>
            </div>

            <div :id="'vx_dropzone_template' + this.unq_id_gen" class="vx_dropzone_template">
                <div class="vx-file-tabs">

                    <div class="vx dz-preview dz-file-preview">
                        <div class="vx dz-image"><img data-dz-thumbnail=""></div>

                        <div class="vx dz-detailin">
                            <div class="vx dz-filename"><span data-dz-name=""></span></div>
                            <div class="vx dz-size"><span data-dz-size=""></span></div>
                        </div>
                        <div class="vx dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div>
                        <div class="vx dz-error-message"><span data-dz-errormessage=""></span></div>

                        <div class="vx dz-success-mark">
                            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
                                <!-- Generator: Sketch 3.2.1 (9971) - http://www.bohemiancoding.com/sketch -->
                                <title>Check</title>
                                <desc>Created with Sketch.</desc>
                                <defs></defs>
                                <g :id="'Page-1' + this.unq_id_gen" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                    <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" :id="'Oval-2' + this.unq_id_gen" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>
                                </g>
                            </svg>
                        </div>

                        <div class="vx dz-error-mark">
                            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
                                <!-- Generator: Sketch 3.2.1 (9971) - http://www.bohemiancoding.com/sketch -->
                                <title>error</title>
                                <desc>Created with Sketch.</desc>
                                <defs></defs>
                                <g :id="'Page-1' + this.unq_id_gen" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                    <g :id="'Check-+-Oval-2' + this.unq_id_gen" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">
                                        <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" :id="'Oval-2' + this.unq_id_gen" sketch:type="MSShapeGroup"></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
import custom_field_set from './fieldset.vue';
const uuidv1 = require('uuid/v1');

export default {
    components : {custom_field_set},
    props : {
        required_fields : {
            type : Array,
            default : function(){
                return []
            }
        },
        other_type : {
            default: false
        },
        cert_no : {

        },
        cert_inst : {

        },
        issue_exp :{
            default : function(){
                return []
            }
        },
        doc_name : {
            type : String
        },
        req_doc_id : {
            required : true
        },
        document_id : {
            default: null
        },
        file_name : {
            type : String,
            default : 'media'
        },
        flag_state : {

        },
        send_or_not : {
            required : true
        },
        expiry_date : {
            type : Array
        },
        upload_btn_id : {
            required : true,
            type : String
        },
        unq_id_gen_man : {
            required : true
        },
        unq_id_gen : {
            required : true
        },
        scanned_files : {
            required : false,
            type : Array
        },
        vx_preview_loc : {
            type : String,
            required : true
        },
        upload_files : {
            type : String,
            required : true
        },
        upload_multiple : {
            default : true,
            type : Boolean
        },
        parallel_uploads : {
            default : 5,
            type : Number
        },
        auto_process : {
            default : true,
            type : Boolean
        },
        max_file_size : {
            default : 5,
            type : Number,
        },
        max_files : {
            default : 10,
            type : Number,
        },
        accepted_files : {

        },
        add_remove_links : {
            default : true,
            type : Boolean
        },
        file_rm_msg : {
            default : "Are you sure you wish to delete this file ?",
            type : String
        }

    },
    data(){
        return {
           sys_file : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL4AAAAiCAYAAADh0GOlAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTcwMTRBMDM2MDY1MTFFNEJBMzRFOUYxNjZCRjhDMjciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTcwMTRBMDQ2MDY1MTFFNEJBMzRFOUYxNjZCRjhDMjciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozMEVCRThCMjVGQTMxMUU0QkEzNEU5RjE2NkJGOEMyNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBNzAxNEEwMjYwNjUxMUU0QkEzNEU5RjE2NkJGOEMyNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pml9QOYAAAbvSURBVHja7FxNaFtHEF7HbtrUbhKlPzb00NZSc2mpDUqhYJ2Kg0TBl8buraiH2j0YCjnJl5wMRTr55IPVQxEpFCKZHnyxqQ8lKNCDDUpLG2gdl16K0p8IipP0z3Z38bdkOtn3qydLsveDwU/andnded/Ozq7fU8/+/r6IGJ9I+UXKHSlbkB+lPBAWFh2CnhYQ/yr7/I+U76V8KeVrKfet2y3ajb5DaOMxKa9AvpLyuZSfrest2okTh9zeG1I+lPJaQL1xKbeJxFj5FCvvZAyH6Oe4i47+ftxHXYuAEb8XN+xFKU8zvU8Dtvm8lPelLEn51qdODO1TohfJ5xwp3+4Cvw8H7GfMQ2eYBINYCPs24jvgpJRXpQxGlB6pm/MeJkEY5Fg0TLoQ4pqUu5BrbALpyKgm0he43iDRU2GGlCnJO0TvKegmSb+c9OgE3iDtJi0lOy/ViXoXPCTlbSmnAug0IMOEnDOkjJN+A+TiRBs2TI4krpNYjbTtJRJBY5h0S0yf2qCkHycROMcmrNaJkXbzlpKdR/y9FrT/upSRgMQvs/RGE7vI6uZBKvV9HFLEd5xg70g5hzqUzGWifxH19ATi+4wPUG+T2J+D3XO4LjCdi8S2YBPS4ghtbjl6pLwppT+AToFEVU2wdRCOIknq65WiwMo0Nsn+YJtNtCIi/xTq6chPib+NerosSXQFa5vqrHfRvuRYbm73WtiHl6W8IOU7n/U1YcZdon1UyJHJtd3GqNxgm9iGYdPfsHRuLuL3GqSvxZMvEVCnwCZC2VBnk5A3RvJzYVgdvDbRF0hK0vBB0k20N0MImmvCR5uk3TxJxfKsTYuQEf85cXBk2cM2s6reEy3sR1Di69Qm6RLt57AqzJCVQUfLuQCE0ynVOtqL+dCbw+Y2TyaeRjlkxJ/DpnqGTCjano34TUR8FdXOI/04T0RFl5Mt7MegjxvP8+CiIY/eZivBBUa0Mr7j9UzplN6wlkF4muN76a9jdVgn/SqQlcqtTScUmc0Gaafo4SsLvrlkz+q8hROIIOD/wLoasi/v2tth0a5U53QENi2BLbou1emzLrE4jsS3sDiWqc49KX8F0O+1LrQ4CpvbMJiVciaE3kfW/RbdnOrYVwotjiXxe6wbLboxx0+FmADXm2z3X+t6i3ZH/LttaPeOdb1FuyP+jpRnWmBbnQ6pX1TYZxNNPen5TYgNdIZ8Vn1elVIylGlMS7lkKKtKWYSNFYNeTcoVjzKFSSlpcfBCTV3KmpSKg55CAW1TrGAci4axTuBzFp8HWDvNjFs4tKeveV91P28K54ftJgL6s4Z2djzGosY8KmUedafZGAbgoxSu1c/ZLKP/jnYV8f8AGaM+07+FxnfZfkBNhD9D2izh7wiId89QRicHLxskJNIEVo66QerWybVT2TxuRg1EjMP5cdLWmDh4+K5ksOsXkxDlx9sYdxbtNjtur0CzZehzndjMGvzj15/9GFeO9cdpLGlC8hQmoUDQWcD3q8gkxmB3wM2ujviK/GcjJv4ubEf5LH+F/F0BEeqszE1PgIyj7GY46ZrKMtAvsbIbjCyDaKvSxHj122nLpC96hUk3OW4vqMl9mU0k/QNhlPgVHz4zlZn6Y9KjZB/FuFdJH/RkrhEbGQSLuJPdPmw0lSPPRHxCc4KkNlFhkhHipnj4ZOeKYenlepqMNUZkuhzS1MNUNkCueSoRNZZxsxdAQL3C1FkaEmbcblhE1JwVj7455gU3fybQp36yYgqPsWhba4joWdjZgo0tg51VL7v6P7e/S/lNyrMdvifJkiWwQnJd03Jm0qO5rtPSvOVRlj7E8daQ06Yw2VMQt/TA77jdUEV7GRH893nc/JkQD9+9MPXHNJY0WWnqGFOa2fWbIv8v4uu05CdEs1MR3bRWnO9P+FzWTXopRLG6YfkOkuoMwVaGlaUc8mI37IhHX8JJkP4NkbHpNOdj5LHNjttP1E+wyeOX+E590gcSn6EvOx73cJT4YIWtKiUEhpRh9ciwFbjiRHyBExjVafXiyeMBBrovOgOTHstdFZFikuTjXkgwu3XYHQMhRpBuxXEDqgFTg1XYn4edEbYhnsVNpZtbQeq2atz0JGqBbRTD+KzKJnsFddY8+nOJEFcfZMRJ4CmREx+6uU14cYM/pKbe3vlBykvC/y8fPEWu/xYH/xeoYwbutiENcsu5F3Ejsz5PNxLMiTXYvUKOM0dxM0shNrIl3FBtp87sLOLm6xRHl1cJ8VsxbkraAogVhPgmn/G9SwYT+7KDnQESyUuGlWAMfpo2HGcWyHGm0UdOD6k9KQ5++cAp578uLCy6GE5n9/cR+W9hFdizrrI4SnB740odc/6K1EWlM6exlJy1brPodvwnwADC2xDrz8AkOAAAAABJRU5ErkJggg==",
           total_count : 0,
           add_count : 0,
           file_added_count : 0,
           added_file_count : 0,
           is_files_empty : true,
           dropzone_el : null,
           req_fields : {
            cert_no : "",
            cert_inst : "",
            flag_state : "",
            issue_exp : ""
           }
        }
    },
    watch : {
        is_file_attached : {
            handler(status){
                this.$emit('file_attached_status',status);
            },
            deep: true
        }
    },
    methods : {
        dataURLtoFile(dataurl, filename) {
            var ext = this.base64MimeType(dataurl);
            ext = ext.split('/')[1];
            ext = ext.split(';')[0];

            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], 'filename.'+ext, {type:mime});
        },
        checkRequiredArr(field){
            if(field){
                if(Array.isArray(field)){
                    if(field.length < 1){
                        return true
                    }
                }
            }
            return false
        },
        base64MimeType(encoded) {
            var result = null;

            if (typeof encoded !== 'string') {
                return result;
            }

            var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

            if (mime && mime.length) {
                result = mime[1];
            }

        return result;
        },
        b64toBlob(b64Data, sliceSize=512){
        var contentType = this.base64MimeType(b64Data)
        const byteCharacters = atob(b64Data.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
        }
    },
    computed : {
        is_file_attached(){
            if(this.scanned_files.length < 1 && this.is_files_empty == true){
                return false;
            }else{
                return true;
            }
        }
    },
    created(){

    },
    mounted() {
Dropzone.autoDiscover = false;
        var com_this = this;
       $("#dropzone_id"+this.unq_id_gen).dropzone({
        url : "/test/create",
        autoProcessQueue: false,
        acceptedFiles: this.accepted_files,
        uploadMultiple: this.upload_multiple,
        parallelUploads: this.parallel_uploads,
        previewsContainer: document.getElementById(this.vx_preview_loc),
        previewTemplate:  document.getElementById("vx_dropzone_template"+this.unq_id_gen).innerHTML,
        addRemoveLinks: this.add_remove_links,
        dictRemoveFile: 'Remove',
        dictFileTooBig: 'Image is bigger than 60MB',
        clickable: document.getElementById(this.upload_files),
        dictRemoveFileConfirmation: this.file_rm_msg, 
 

        // The setting up of the dropzone
        init:function() {

            if(com_this.document_id != null){
                if(com_this.document_id.type == "REQUIRED_DOCS" || com_this.document_id.type == "OTHER_DOCS" || com_this.document_id.type == "UNKNOWN_DOCS"){
                    // Saved Files
                    if(com_this.document_id.id != ""){
                        var un_idd = uuidv1();
                        com_this.$emit('file_attached',{
                            com_id : com_this.unq_id_gen,
                            is_dummy : "true",
                            uuid : un_idd,
                            blob_file :com_this.dataURLtoFile(com_this.sys_file,"vx_documrny.pdf"),
                            upload : {
                                uuid : un_idd
                            }
                        })
                        var mockFile = {
                            upload : {
                                uuid : un_idd,
                                is_dummy : "true"
                            },
                             name: "file.jpg", sea_req_doc_id : com_this.document_id.id, document_id: com_this.document_id.document_id, size: 12345, type: 'image/jpeg' };       
                        this.options.addedfile.call(this, mockFile);
                        this.options.thumbnail.call(this, mockFile, "/images/pdf_file1.png");
                        mockFile.previewElement.classList.add('dz-success');
                        mockFile.previewElement.classList.add('dz-complete');
                    }
                }
                if(com_this.document_id.type == "PROFILE_PIC"){
                    var un_idd = uuidv1();
                        com_this.$emit('file_attached',{
                            com_id : com_this.unq_id_gen,
                            is_dummy : "true",
                            uuid : un_idd,
                            blob_file :com_this.dataURLtoFile(com_this.sys_file,"vx_documrny.pdf"),
                            upload : {
                                uuid : un_idd
                            }
                        })
                        var mockFile = {
                            upload : {
                                uuid : un_idd,
                                is_dummy : "true"
                            },
                             name: "file.jpg", sea_req_doc_id : com_this.document_id.id, document_id: com_this.document_id.document_id, size: 12345, type: 'image/jpeg' };       
                    this.options.addedfile.call(this, mockFile);
                    this.options.thumbnail.call(this, mockFile, "/document/get_document?doc_id="+com_this.document_id.document_id);
                    mockFile.previewElement.classList.add('dz-success');
                    mockFile.previewElement.classList.add('dz-complete');
                }
                

            }
            
            var myDropzone = this;
            com_this.dropzone_el = myDropzone;

                this.on("addedfile", function(file) {
                    var file_uuid = file.upload.uuid;
                     com_this.is_files_empty = false;
                        var reader = new FileReader();
                        if(file.type == "vx_scan"){
                            file = file.file
                        }
                        reader.addEventListener("loadend", function(event) { 
                            com_this.$emit('file_attached',{
                            com_id : com_this.unq_id_gen,
                            blob_file :com_this.dataURLtoFile(event.target.result,"vx_documrny.pdf"),
                            uuid : file_uuid,
                            is_dummy : "false"
                            })
                           
                        });
                        var file_read = reader.readAsDataURL(file)
                 });

       
                

            this.on("fileLoaded",function(){
            });

            this.on("removedfile",function(file){
                    //  console.log(file);
                     com_this.$emit('remove_scanned_file',file.upload.uuid)
                     if(myDropzone.getAcceptedFiles().length == 0){
                         com_this.is_files_empty = true;
                     }
                     console.log(file);
                axios.post('/document/delete_document',{
                    document_id : file.document_id,
                    sea_req_doc_id : file.sea_req_doc_id
                });
            });
            // this.on("removedfile", function(file) {
            //     console.log(file);
            //     axios.post('/document/delete_document',{
            //         document_id : file.document_id,
            //         sea_req_doc_id : file.sea_req_doc_id
            //     });
            // });
            
            document.getElementById("attachFile"+com_this.unq_id_gen_man).addEventListener("click", function (e) {
                com_this.scanned_files.forEach(file => {

     
                    if(typeof file.scanned_1st_page !== 'undefined'){
                        var scanned_file = { 
                            name: file.file_name,
                            size: file.file_size,
                            type : "vx_scan",//scan_doc_dataUrl
                            file : file.blob_file,
                            is_dummy : "false",
                            upload : {
                                uuid : file.uuid
                            }
                        };
            
                        // Call the default addedfile event handler

                        // And optionally show the thumbnail of the file:
                        //  myDropzone.emit("thumbnail", scanned_file, file.scanned_1st_page);
                        // myDropzone.emit("complete", scanned_file);


                        myDropzone.options.addedfile.call(myDropzone, scanned_file);
                        myDropzone.options.thumbnail.call(myDropzone, scanned_file, file.scanned_1st_page);
                        scanned_file.previewElement.classList.add('dz-success');
                        scanned_file.previewElement.classList.add('dz-complete');
                    }
                

            });
            
            });
        },
        error: function(file, response) {
            if($.type(response) === "string")
                var message = response; //dropzone sends it's own error messages in string
            else
                var message = response.message;
            file.previewElement.classList.add("dz-error");
            _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
            $('#waitModal').modal('show');  
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                node = _ref[_i];
                _results.push(node.textContent = message);
            }
            return _results;
        },
        success: function(file,response) {
            if(response.status == "SUCCESS"){
                com_this.$emit("file_uploaded",{
                    no_uploaded : 1,
                    doc_id : response.doc_id,
                    doc_saved : response.doc_saved,
                    issue_exp : com_this.issue_exp
                });
            }
        }
       });
       this.$emit("fileLoaded");
    }
}
</script>

<style>
.dropzone .dz-preview.dz-image-preview.dz-details {
    -webkit-transition: opacity 1  !important;
    -moz-transition: opacity 1  !important;
    -ms-transition: opacity 1  !important;
    -o-transition: opacity 1  !important;
    transition: opacity 1 linear  !important;
}

.dropzone{
    margin-bottom: 5px !important
}
.vx_dropzone_template{
    display: none
}

.vx.dz-preview.dz-complete.dz-image-preview{
    border:1px solid red !important;
    /* width: 90px !important */
}
.vx.dz-details{
    z-index: 20 !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    opacity: 1 !important;
    font-size: 13px;
    min-width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    text-align: left !important;
    color: red !important;
    line-height: 150% !important;
}

/* image css */
.vx.dz-preview.dz-complete.dz-image-preview {
    width: 40%;
    height: 100% !important;
    margin: auto;
    padding: 10px;
}
.vx.dz-image{
    width: 15%;
    float: left;
    height: 100% !important;
    margin-right: 10px !important;
}

.dropzone {
    border:1px solid rgb(226, 226, 241) !important;
    padding: 0 !important;
}
.dropzone .dz-preview .dz-image {
    border-radius: 5px !important;
    overflow: hidden;
    width: 50px !important;
    height: 100% !important;
    position: relative;
    display: block;
    z-index: 10;
}
.dropzone .dz-preview .dz-image > img {
    height: 70px !important;
}
.vx.dz-size{
    margin-bottom: 0 !important;
    font-size: 11px !important;
}

.vx.dz-filename {
    font-size: 12px !important;
    width: 100% !important
}
.vx.dz-filename span{
    width: 150% !important
}
.vx.dz-details {
    margin-left: 15%;
    height: 200px;
}
.vx.dz-details:hover{
    opacity: 1 !important;
}

.vx.dz-detailin{
    padding-left: 15px !important
}

.dropzone .dz-preview:hover {
    z-index: 0 !important;
    opacity: 1 !important;
}

   .dropzone .dz-preview:hover .dz-image img {
      -webkit-transform: scale(1) !important;
      -moz-transform: scale(1) !important;
      -ms-transform: scale(1) !important;
      -o-transform: scale(1) !important;
      transform: scale(1) !important;
      -webkit-filter: blur(0) !important;
      filter: blur(0) !important; 
    }


.dropzone .dz-preview:hover .dz-image img {
	-webkit-filter: sepia(100%);
	filter: sepia(100%);
	-webkit-transition: .3s ease-in-out;
	transition: .3s ease-in-out;
}
.dropzone .dz-preview:hover .dz-image:hover img {
	-webkit-filter: sepia(0);
	filter: sepia(0);
}
.vx-file-tabs{
    border:1px solid whitesmoke !important;
    width: 100% !important;
}
.vx.dz-preview.dz-file-preview{
    margin: 0px !important;
    padding : 5px !important;
    min-height:90px !important
}
.vx_drag_files{
    padding: 5px !important;
    text-align: left
}

.dropzone .dz-preview .dz-progress {
    position: absolute;
    height: 16px;
    left: 170px !important;
    top: 50px !important;
    width: 45px;
    margin-left: -160px !important;
    border-radius: 8px;
    overflow: hidden;
}

</style>
